import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import type { ReactElement } from "react";
import {
    StyledButton,
    StyledButtonContainer,
    StyledContainer,
    StyledImageContainer,
    StyledList,
    StyledSubTitle,
    StyledTitle,
} from "./styles";

type EmptyStateWithStepsProps = {
    image: ReactElement;
    titleI18nKey: string;
    subtitleI18nKey?: string;
    steps: readonly Translatable[];
    buttonI18Key?: string;
    className?: string;
    onDismiss(): void;
};

const EmptyStateWithSteps = (props: EmptyStateWithStepsProps) => {
    const {
        image,
        steps,
        titleI18nKey,
        subtitleI18nKey,
        buttonI18Key = "si.common.button.lets_go",
        className,
        onDismiss,
    } = props;

    return (
        <StyledContainer
            className={className}
            data-automation="empty-state-with-steps"
        >
            <div>
                <StyledImageContainer data-automation="image-wrapper">{image}</StyledImageContainer>
                <I18n
                    element={StyledTitle}
                    data-automation="title-text"
                    translatable={{ key: titleI18nKey }}
                />
                {subtitleI18nKey ? <I18n
                        element={StyledSubTitle}
                        data-automation="subtitle-text"
                        translatable={{ key: subtitleI18nKey }}
                    /> : null}
                <StyledList data-automation="steps-list">
                    {steps.map((step, i) => (
                        <I18n
                            translatable={step}
                            element="li"
                            data-automation="step-item"
                            key={i}
                        />
                    ))}
                </StyledList>
                <StyledButtonContainer>
                    <StyledButton
                        type="primary"
                        onClick={onDismiss}
                        dataAutomation="dismiss-button"
                    >
                        {translate(buttonI18Key)}
                    </StyledButton>
                </StyledButtonContainer>
            </div>
        </StyledContainer>
    );
}

export default EmptyStateWithSteps;
